import { PaymentTypeEnum } from 'app/constants/Enums'
import { useCurrentConfig, useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import { useEffect, useState } from 'react'

export const allPaymentOptions = [
  PaymentTypeEnum.credit_card,
  PaymentTypeEnum.invoice,
  PaymentTypeEnum.paypal
]

export const usePaymentOptions = () => {
  const customer = useCurrentCustomer()
  const { payment_options } = useCurrentConfig() || {}
  const [options, setOptions] = useState<PaymentTypeEnum[]>(allPaymentOptions)

  useEffect(() => {
    let availableOptions = allPaymentOptions

    if (payment_options) {
      availableOptions = availableOptions.filter((o) => payment_options.includes(o))
    }

    if (customer?.customer_type === 'private') {
      availableOptions = availableOptions.filter((o) => o !== PaymentTypeEnum.invoice)
    }

    setOptions(availableOptions)
  }, [customer, payment_options])

  return { options }
}
